import React from 'react'
import Layout from '../../src/Me/Me'
import Home from '../../src/Me/Routes/Home'

export default function Index() {
    return (
        <Layout title="Home">
            <Home />
        </Layout>
    )
}